import theme from '../../../../lib/theme';
import { InputStatusProps } from './InputStatus';

const {
  colors,
  scale,
  animations,
  layouts,
  font: {
    heights,
    spacings,
    families,

    ...font
  },
} = theme;

export default ({ status }: InputStatusProps) => ({
  container: {
    ...layouts.spacedRow('xxxs'),

    animation: `150ms ${animations.fadeIn} linear`,
    marginTop: scale.xxs,
  },

  message: {
    color: colors[status],
    fontSize: font.s,
    fontFamily: families.primary,
    lineHeight: heights.s,
    fontWeight: font.normal,
    letterSpacing: spacings.m,
  },

  icon: {
    color: `${colors[status]} !important`,
    width: `${scale.s} !important`,
    height: `${scale.s} !important`,
  },
});
